import React from "react";
import { LoadingBar } from "../LoadingComponents/LoadingBar";
import "./FacesheetFAP.scss";
import moment from "moment";
import { getDocumentPrettyName } from "../../services/faDocumentationService";

export const FacesheetFAP = ({
    faDocumentation,
    isFaDocumentationLoading,
    hasPrintedDate,
    title,
    documentDropdownItems,
}) => {
    return (
        <div className="facesheet_faDocuments">
            <div className="uploaded-faDocuments">
                <LoadingBar isLoading={isFaDocumentationLoading}>
                    <div>
                        <div className="title"> {title}</div>
                        <div className="fap-facesheet-documents">
                            <div className="label name">Document Name</div>
                            {hasPrintedDate === true && <div className="label">Printed</div>}
                            <div className="label">Sent</div>
                            <div className="label">Due</div>
                            <div className="label">Received</div>
                            <div className="label">Status</div>
                        </div>
                        {faDocumentation?.map(x => (
                            <div className="fap-facesheet-documents-row">
                                <div className="fap-facesheet-documents">
                                    <div className="fap-item name" key={x.globalId + x.documentName}>
                                        {getDocumentPrettyName(documentDropdownItems, x.documentName)}
                                    </div>
                                    {hasPrintedDate === true && (
                                        <div className="fap-item" key={x.globalId + x.documentName + "printedDate"}>
                                            {x.printedDate !== null &&
                                            x.printedDate !== undefined &&
                                            x.printedDate !== ""
                                                ? moment(x.printedDate).format("MM/DD/YYYY")
                                                : "N/A"}
                                        </div>
                                    )}
                                    <div className="fap-item" key={x.globalId + x.documentName + "sentDate"}>
                                        {x.sentDate !== null && x.sentDate !== undefined && x.sentDate !== ""
                                            ? moment(x.sentDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </div>
                                    <div className="fap-item" key={x.globalId + x.documentName + "dueDate"}>
                                        {x.dueDate !== null && x.dueDate !== undefined && x.dueDate !== ""
                                            ? moment(x.dueDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </div>
                                    <div className="fap-item" key={x.globalId + x.documentName + "receivedDate"}>
                                        {x.receivedDate !== null &&
                                        x.receivedDate !== undefined &&
                                        x.receivedDate !== ""
                                            ? moment(x.receivedDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </div>
                                    <div className="fap-item" key={x.globalId + x.documentName + "status"}>
                                        {x.status === "ReceivedIncomplete"
                                            ? "Received Incomplete"
                                            : x.status === "ReceivedComplete"
                                            ? "Received Complete"
                                            : ""}
                                    </div>
                                </div>
                                <div className="comment" key={x.globalId + x.documentName + "comment"}>
                                    <div className="comment-title" style={{ marginRight: "5px" }}>
                                        Comment:{" "}
                                    </div>
                                    <div>{x.comment === "" || x.comment == null ? "N/A" : x.comment}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </LoadingBar>
            </div>
        </div>
    );
};
